import { render, staticRenderFns } from "./WapMyShipment.vue?vue&type=template&id=c43520c6&scoped=true&"
import script from "./WapMyShipment.vue?vue&type=script&lang=js&"
export * from "./WapMyShipment.vue?vue&type=script&lang=js&"
import style0 from "./WapMyShipment.vue?vue&type=style&index=0&id=c43520c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43520c6",
  null
  
)

export default component.exports